import {
  all,
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import {
  getSettings,
  changeSettings,
} from 'api/settings';
import { SETTINGS_ACTION_TYPES, setSettings, setSettingsLoading } from 'store/actions/settings.actions';

const formatSettings = (settingsArray) => {
  return settingsArray.reduce((result, setting) => {
    result[setting.id] = setting.value;
    return result;
  }, {})
}

const formatObjectSettings = (settingsObject) => {
  return Object.keys(settingsObject).reduce((result, settingKey) => {
    result[settingKey] = settingsObject[settingKey].value;
    return result;
  }, {})
}

function* loadSettingsFlow() {
  try {
    const { data } = yield call(getSettings);
    yield put(setSettings(formatSettings(data)));
  } catch (e) {
    yield put(setSettingsLoading(false));
  }
}

function* editSettingsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(changeSettings, payload);
    yield put(setSettings(formatObjectSettings(data)));
    resolve();
  } catch (e) {
    yield put(setSettingsLoading(false));
    reject(e?.response?.data);
  }
}

export default function* () {
  yield all([
    takeLatest(SETTINGS_ACTION_TYPES.LOAD_SETTINGS, loadSettingsFlow),
    takeLatest(SETTINGS_ACTION_TYPES.EDIT_SETTINGS, editSettingsFlow),
  ]);
}
